// 멀티셀렉트 콤보박스 공통 컴포넌트
// props:
//   options       : string[] | { value, label }[]
//   value         : string[]  — 현재 선택된 값 배열
//   onChange      : (string[]) => void
//   placeholder   : string    — 0개 선택 시 표시 텍스트 (default: "전체")
//   showAllOption : boolean   — "전체" 체크박스 표시 여부 (default: true)
//   className     : string
import React, { useState, useEffect, useRef } from 'react';
import './MultiSelectCombo.css';

const getVal = (opt) => (typeof opt === 'string' ? opt : opt.value);
const getLbl = (opt) => (typeof opt === 'string' ? opt : opt.label);

const MultiSelectCombo = ({
  options       = [],
  value         = [],
  onChange,
  placeholder   = '전체',
  showAllOption = true,
  className     = '',
}) => {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target))
        setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const toggle = (optVal) => {
    if (value.includes(optVal)) onChange(value.filter(v => v !== optVal));
    else                        onChange([...value, optVal]);
  };

  const displayText =
    value.length === 0 ? placeholder :
    value.length === 1 ? value[0]    :
                         `${value.length}개 선택`;

  return (
    <div className={`msc-wrap ${className}`} ref={wrapRef}>
      <button
        type="button"
        className="msc-btn"
        onClick={() => setOpen(p => !p)}
      >
        <span className="msc-label">{displayText}</span>
        <span className="msc-caret">▼</span>
      </button>

      {open && (
        <div className="msc-dropdown">
          {options.length === 0 ? (
            <div className="msc-empty">항목 없음</div>
          ) : (
            <>
              {showAllOption && (
                <>
                  <label className="msc-item msc-item-all">
                    <input
                      type="checkbox"
                      checked={value.length === 0}
                      onChange={() => onChange([])}
                    />
                    전체
                  </label>
                  <hr className="msc-sep" />
                </>
              )}
              {options.map(opt => {
                const v = getVal(opt);
                const l = getLbl(opt);
                return (
                  <label key={v} className="msc-item">
                    <input
                      type="checkbox"
                      checked={value.includes(v)}
                      onChange={() => toggle(v)}
                    />
                    {l}
                  </label>
                );
              })}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default MultiSelectCombo;
